// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3cY8u","list":"PatternAutocomplete_list__XfQ6v"};